import styled from '@emotion/styled-base';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { config } from 'src/modules/onboarding/config/config';
import { color, font } from 'src/shared/styles/variables';

const Link = styled('a')({
    color: color.royalBlue,
    textDecoration: 'underline',
});

const StyledCrisisContainer = styled('div')({
    borderRadius: 5,
    backgroundColor: color.catskillWhite,
    width: '100%',
    padding: 10,
    minHeight: 50,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
});
const CrisisTitle = styled('h3')(
    {
        color: color.bismark,
    },
    font.black(font.size.medium),
);
const CrisisDescription = styled('p')({
    color: color.blueBayoux,
    ...font.book(font.size.base),
});

export const CrisisContainer = ({ componentKey, setShowCrisisModal }) => {
    const { t } = useTranslation();
    let crisisDescriptionTextObj: {
        title: string | null;
        descKey: string;
        components: Array<React.ReactNode>;
    };
    switch (componentKey) {
        case 'contact_us':
            crisisDescriptionTextObj = {
                title: null,
                descKey: 'your_on_your_way_screen.contact_us',
                components: [
                    <Link
                        key={`${config.csmMail}_${new Date().getTime()}`}
                        onClick={() => window.open(`mailto:${config.csmMail}`, '_blank')}
                    />,
                ],
            };
            break;
        default:
            crisisDescriptionTextObj = {
                title: t('onboarding:your_on_your_way_screen.crisis.title'),
                descKey: 'your_on_your_way_screen.crisis.description',
                components: [
                    <span key={`crisis_modal_1_${new Date().getTime()}`}></span>,
                    <Link
                        key={`crisis_modal_1_${new Date().getTime()}`}
                        onClick={() => setShowCrisisModal(true)}
                    />,
                ],
            };
            break;
    }

    return (
        <StyledCrisisContainer>
            {crisisDescriptionTextObj.title && (
                <CrisisTitle>{crisisDescriptionTextObj.title}</CrisisTitle>
            )}
            <CrisisDescription>
                <Trans
                    t={t}
                    ns={'onboarding'}
                    i18nKey={crisisDescriptionTextObj.descKey}
                    components={crisisDescriptionTextObj.components}
                />
            </CrisisDescription>
        </StyledCrisisContainer>
    );
};
